export const generatePermissionsForRoleMethod = {
  mountRolePermissionsAndSelects() {
    this.form.permissions.splice(0);
    this.form.permissions = [...this.getPermissoes];
    this.form.queuesPermitidos_ids = [...this.getSelectedFilas];
    this.form.departamentosPermitidos_ids = [...this.getSelectedDepartamentos]
    this.form.agentesPermitidos_ids = [...this.getSelectedOperadores];
    this.form.ramaisRelatoriosPabxPermitidos_ids = [
      ...this.getSelectedRamaisRelatoriosPABX,
    ];
    this.form.tagsRelatorioPabxPermitidos_ids = [
      ...this.getSelectedTagsRelatoriosPABX,
    ];
    this.form.conferenciasPermitidos_ids = [...this.getSelectedConferencias];
    this.form.ramaisMonitorRamaisPermitidos_ids = [
      ...this.getSelectedRamaisMonitorRamais,
    ];
    this.form.pesquisasPermitidos_ids = [
      ...this.getSelectedPesquisasSatisfacao,
    ];
    this.form.tagsPesquisaPermitidos_ids = [
      ...this.getSelectedTagsPesquisaSatisfacao,
    ];
    this.form.rolesPermitidos_ids = [...this.getSelectedRoles];
  },
};
